var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbcLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 105.7 105.7"
    },
    viewBox: "0 0 105.7 105.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st5{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.6 52.8C96.6 77 77 96.6 52.8 96.6S9.1 77 9.1 52.8C9.1 28.6 28.7 9 52.9 9s43.7 19.7 43.7 43.8",
    className: "st5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.8 0C23.7 0 0 23.7 0 52.8s23.7 52.8 52.8 52.8 52.8-23.7 52.8-52.8S82 0 52.8 0m0 88.1c-19.5 0-35.2-15.8-35.2-35.2s15.8-35.2 35.2-35.2C72.3 17.7 88 33.5 88 52.9S72.3 88.1 52.8 88.1",
    style: {
      fill: "#0555b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4 52.8c0 9.7-7.9 17.6-17.6 17.6s-17.6-7.9-17.6-17.6c0-9.7 7.9-17.6 17.6-17.6s17.6 7.9 17.6 17.6",
    style: {
      fill: "#ce202d"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "test",
    d: "M88.1 21.6c0 2.2-1.8 3.9-3.9 3.9s-3.9-1.8-3.9-3.9c0-2.2 1.8-3.9 3.9-3.9s3.9 1.7 3.9 3.9",
    className: "st5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbcLogo);
export default __webpack_public_path__ + "static/media/abc-logo.9aa273e20f2acc3f98bc15ff4bd870f1.svg";
export { ForwardRef as ReactComponent };